<style scoped>
.justify {
	text-align: justify;    
}
.firstHead {
	font-size: 1.5em;
	/* font-weight: bold; */
}
.secondHead {
	font-size: 1.25em;
	font-weight: bold;
	margin: 8px 0px;
}
.thirdHead {
	font-size: 1.1em;
	font-weight: bold;
	margin: 8px 0px;
}
.fourthHead {
	font-weight: bold;
	margin: 8px 0px;
}
.indent {
	text-indent: 0em;
}
.text {
	margin: 8px 0px;
}
ul {
	margin: 8px 0px;
}
</style>

<template>
    <app-layout class="feed-single-page-template">
		<Row type="flex" justify="center" style="height: 100vh">
			<Col :span="24" style="text-align: center; top: 40vh;">
				<h1>
				Coming soon...
				</h1>
			</Col>
		</Row>
    </app-layout>
</template>

<script>
  export default {
    name: 'PrivacyPolicyComponent'
  }
</script>
